import get from 'lodash/get';

export const getDefaultValues = (props) => {
  if (get(props, 'transfer.propertyAddress1')) {
    return {
      propertyAddress1: get(props, 'transfer.propertyAddress1'),
      propertyAddress2: get(props, 'transfer.propertyAddress2'),
      propertyState: get(props, 'transfer.propertyState'),
      propertyCity: get(props, 'transfer.propertyCity'),
      propertyZipcode: get(props, 'transfer.propertyZipcode'),
    };
  } else {
    if (
      get(props, 'transfer.purpose') === 'Earnest Money Deposit for Purchase'
    ) {
      return {
        propertyAddress1: get(props, 'client.address1'),
        propertyAddress2: get(props, 'client.address2'),
        propertyState: get(props, 'client.state'),
        propertyCity: get(props, 'client.city'),
        propertyZipcode: get(props, 'client.zipcode'),
      };
    } else {
      return {
        propertyAddress1: get(props, 'client.propertyAddress1'),
        propertyAddress2: get(props, 'client.propertyAddress2'),
        propertyState: get(props, 'client.propertyState'),
        propertyCity: get(props, 'client.propertyCity'),
        propertyZipcode: get(props, 'client.propertyZipcode'),
      };
    }
  }
};
